import {
    WITH_URL_GENERATOR,
} from '../store/withUrlGeneratorMiddleware';

import getRequestHeaders from '../utils/getRequestHeaders';
import throwResponseError from '../utils/throwResponseError';
import handleValidationErrors from '../utils/handleValidationErrors';

/**
 * Constants
 */

const GET_PAGES_ACTION = 'site@GET_PAGES_ACTION';
const GET_MENU_ACTION = 'site@GET_MENU_ACTION';

const SET_PAGES_ACTION = 'site@SET_PAGES_ACTION';
const SET_MENU_ACTION = 'site@SET_PAGES_ACTION';

/**
 * Actions creator
 */

const setPagesAction = (data) => {
    return {
        type: SET_PAGES_ACTION,
        payload: data,
    };
};

const setMenuAction = (data) => {
    return {
        type: SET_MENU_ACTION,
        payload: data,
    };
};

const getPagesAction = (urlGenerator, id) => ({
    type: WITH_URL_GENERATOR,
    payload: (err, dispatch) => {
        return fetch(`/api/page`, {
            method: 'GET',
            credentials: 'include',
        })
        .then(response => throwResponseError(response))
        .then(response => response.json())
        .then(
            newData => dispatch(setPagesAction(newData)),
        );
    },
});

const getMenuAction = () => {

};

/**
 * Exports
 */
const SiteActions = {
    getPagesAction,
    getMenuAction,
};

export default SiteActions;
export {
    GET_PAGES_ACTION,
    GET_MENU_ACTION,
    SET_PAGES_ACTION,
    SET_MENU_ACTION,
    setPagesAction,
    getPagesAction,
    setMenuAction,
    getMenuAction,
};



// WEBPACK FOOTER //
// ./actions/SiteActions.js